import { Component, OnInit, Input } from '@angular/core';
import { PropertyListingService } from '../../../../../shared/providers/property-listing.service';
import { CommonService } from '../../../../../shared/providers/common.service';
import { ValidationService } from '../../../../../shared/providers/validation.service';
import { ActivatedRoute, Params } from '@angular/router';
import { NewsTickerDetailsModel } from '../../../../../shared/models/NewsTickerDetailsModel';
import { LoaderService } from '../../../../../shared/providers/loader.service';

@Component({
  selector: 'app-credit-profile-statistics',
  templateUrl: './credit-profile-statistics.component.html',
  styleUrls: ['./credit-profile-statistics.component.css']
})
export class CreditProfileStatisticsComponent implements OnInit {

  constructor(private propertyListing: PropertyListingService, private Loader: LoaderService, private commonService: CommonService, public Validation: ValidationService, protected activatedRoute: ActivatedRoute) { }

  @Input() tickerSymbol = null;
  statistics = {} as any;
  statisticsDetails = {} as any;
  showStatistics = false;
  newsDetail = {} as NewsTickerDetailsModel;
  ngOnInit() {
    this.Loader.display(true);
    this.loadData();
  }
  loadData() {
    if (this.tickerSymbol != null && this.tickerSymbol != '' && this.tickerSymbol != undefined) {
      this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6104).subscribe(response => {
        if (!response.IsLatestAvailable) {
          this.getStatistics();

        }
        else {
          this.statisticsDetails = JSON.parse(response.DataJson);
          this.statistics = this.statisticsDetails != null ? this.statisticsDetails?.quoteSummary?.result[0] : null;

          this.showStatistics = true;
          this.Loader.display(false);
        }
      });
    }
  }

  getStatistics() {
    this.propertyListing.GetStatitics(this.tickerSymbol).subscribe(response => {
      if (response != null) {
        this.statisticsDetails = response;
        this.statistics = this.statisticsDetails != null ? this.statisticsDetails?.quoteSummary?.result[0] : null;
        if (this.statistics != null) {
          this.newsDetail.DataJson = JSON.stringify(response);
          this.newsDetail.Ticker = this.tickerSymbol;
          this.newsDetail.TypeId = 6104;
          this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(response => {
          });
        }
      }
      this.showStatistics = true;
      this.Loader.display(false);
    });
  }

}
